








import Vue from "vue";

export default Vue.extend({
    name: "LayoutBlank",
    computed: {
        isNeedNavBar() {
            // 暂时屏蔽nav bar
            return false;
        },
        navBarTitle() {
            return this.$t(this.$route.meta.title);
        }
    },
    methods: {
        onClickLeft() {
            if (this.$route.meta.parentPath) {
                return (window.location.href = this.$route.meta.parentPath);
            }
            history.back();
        }
    }
});
